import React from 'react';
import { StarRating } from './StarRating';
import { featuredReview, reviews } from '../data/reviews';
import { shop } from '../data/shop';
export function ReviewsSection() {
  return <section id="reviews" aria-labelledby="reviews-heading" className="bg-surface py-20 lg:py-28" data-id="element-220" data-mp="1khjuqlx396f3">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-221" data-mp="1ggi1clpurol1">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-222" data-mp="1gfymjdvi1gb8">
          <div data-id="element-223" data-mp="1biq0313biq46">
            <p className="mb-3 text-sm font-semibold text-accent" data-id="element-224" data-mp="1bj87mtvfkqre">Reviews</p>
            <h2 id="reviews-heading" className="font-display text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-225" data-mp="16ou7yf9qjxgx">
              What Helena drivers say
            </h2>
          </div>
          <div className="flex items-center gap-4" data-id="element-226" data-mp="wtadzyeqf8ut">
            <span className="font-display text-4xl font-bold" data-id="element-227" data-mp="wqeew6r5ee4s">{shop.rating}</span>
            <div data-id="element-228" data-mp="ssqggtq8y385">
              <StarRating data-id="element-229" data-mp="nrkm6rgxu7wi" />
              <p className="mt-1 text-sm text-muted" data-id="element-230" data-mp="nr16lherfvln">from {shop.reviewCount} Google reviews</p>
            </div>
          </div>
        </div>

        <div className="mt-14 grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-231" data-mp="3lxbrktnzarwe">
          <figure className="lg:col-span-7" data-id="element-232" data-mp="3qqen37cbgbf8">
            <blockquote className="font-display text-2xl font-medium leading-snug tracking-tight sm:text-3xl" data-id="element-233" data-mp="3qr7mfn8y3ync">
              “{featuredReview.quote}”
            </blockquote>
            <figcaption className="mt-8" data-id="element-234" data-mp="3h035ihzpm3pv">
              <span className="block font-semibold" data-id="element-235" data-mp="8jzzego8wn3n">{featuredReview.name}</span>
              <span className="text-sm text-muted" data-id="element-236" data-mp="8hxbc26nl41k">{featuredReview.vehicle}</span>
            </figcaption>
          </figure>

          <div className="divide-y divide-line border-t border-line lg:col-span-5 lg:border-l lg:border-t-0 lg:pl-12" data-id="element-237" data-mp="3vopvddmyqdvc">
            {reviews.map(review => <figure key={review.name} className="py-8 first:pt-8 lg:first:pt-0" data-id="element-238" data-mp="4gbuk5r005m3">
                <StarRating size="sm" data-id="element-239" data-mp="2k7pwfz6410sc" />
                <blockquote className="mt-4 leading-relaxed" data-id="element-240" data-mp="2p8dxldo1yy0a">“{review.quote}”</blockquote>
                <figcaption className="mt-4 text-sm" data-id="element-241" data-mp="2p6172c48bfbm">
                  <span className="font-semibold" data-id="element-242" data-mp="uqubw3tmml0m">{review.name}</span>
                  <span className="text-muted" data-id="element-243" data-mp="pskgbs3zpieh"> · {review.vehicle}</span>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}